import React from 'react';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFnsV3';
import { isValid } from 'date-fns';

import styles from './dateTime.style';

const DateTime = ({
  value,
  name,
  error,
  onChange,
  is24hr = false,
  ...rest
}) => {
  const handleChange = (newValue) => {
    if (newValue && newValue instanceof Date && isValid(newValue)) {
      onChange(newValue.toISOString());
    } else {
      onChange(newValue);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DateTimePicker
        showToolbar={false}
        format="dd-MM-yyyy HH:mm"
        ampm={!is24hr}
        slotProps={{
          popper: {
            sx: {
              ...styles.popper,
            },
          },

          textField: {
            variant: 'outlined',
            error: !!error,
            sx: {
              ...styles.textfield,
              ...(!!error && styles.errorTextInput),
            },
          },
        }}
        value={value ? new Date(value) : null}
        onChange={handleChange}
        {...rest}
        label=""
      />
    </LocalizationProvider>
  );
};

export default DateTime;
